export default __webpack_public_path__ + "static/media/redux-saga.a4204525.svg";